import { render } from "./ChatHeader.vue?vue&type=template&id=43caa4be&scoped=true"
import script from "./ChatHeader.vue?vue&type=script&lang=js"
export * from "./ChatHeader.vue?vue&type=script&lang=js"

import "./ChatHeader.vue?vue&type=style&index=0&id=43caa4be&lang=scss&scoped=true"

import exportComponent from "D:\\myGithub\\customer-web-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43caa4be"]])

export default __exports__